// extracted by mini-css-extract-plugin
export var hidden = "uploadImageButton-module--hidden--6cd3a";
export var uploadImageButton = "uploadImageButton-module--uploadImageButton--99a30";